angular.module("ainapp")
    .controller("leaveMonthlyReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Monthly Leave Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), 1, 1);
                var enddate = new Date(new Date().getFullYear(), 12, 31);

                $scope.filter = {
                    VoucherNo: "",
                    EmployeeIds: [],
                    FromDate: startdate,
                    ToDate: enddate,
                    BranchId: "",
                }

                $scope.load = false;
                $scope.isFilter = false;

            }
            $scope.Init();


            $scope.employeeSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.EmployeesInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    //toastr.error("NetworkError");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 20
            };

            $scope.selectEmployeeOptions = {
                placeholder: "Select Employees...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.employeeSelectDataSource
            };


            $scope.employeeSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.EmployeesInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    //toastr.error("NetworkError");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 20
            };

            $scope.selectEmployeeOptions = {
                placeholder: "Select Employees...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.employeeSelectDataSource
            };




            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                        o.data.FromDay = $scope.filter.FromDate.getDate();
                        o.data.FromYear = $scope.filter.FromDate.getFullYear();
                        o.data.AccountIds = $scope.filter.AccountIds;
                        o.data.EmployeeIds = $scope.filter.EmployeeIds;

                        o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                        o.data.ToDay = $scope.filter.ToDate.getDate();
                        o.data.ToYear = $scope.filter.ToDate.getFullYear();

                        MainService.EmployeeLeaveReport(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })

                    },

                },
                change: function (data) {
                    if (data.items.length > 0) {
                        data.sender._aggregateResult.Balance.count = 0;
                        angular.forEach(data.items, function (e) {
                            e.aggregates.Balance.count = Math.abs(e.aggregates.Assigned.sum - e.aggregates.Applied.sum);
                            e.aggregates.Balance.count = Math.round(e.aggregates.Balance.count * 100) / 100;

                            angular.forEach(e.items, function (aa) {
                                aa.aggregates.Balance.count = Math.abs(aa.aggregates.Assigned.sum - aa.aggregates.Applied.sum);
                                aa.aggregates.Balance.count = Math.round(aa.aggregates.Balance.count * 100) / 100;
                            })

                        })
                        data.sender._aggregateResult.Balance.count = Math.abs(data.sender._aggregateResult.Assigned.sum - data.sender._aggregateResult.Applied.sum);
                        data.sender._aggregateResult.Balance.count = Math.round(data.sender._aggregateResult.Balance.count * 100) / 100;
                    }
                },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "MonthName": {
                                type: "string",
                                editable: false,
                            },
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },
                            "PayrollComponent.Name": {
                                type: "string",
                                editable: false,
                            },
                            Applied: {
                                type: "number",
                                editable: false,
                            },
                            Assigned: {
                                type: "number",
                                editable: false,
                            },
                            Balance: {
                                type: "number",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            DateString: {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: false,
                serverSorting: false,
                serverFiltering: false,
                pageSize: 20,
                group: [{
                    field: "Employee.Name",
                    aggregates: [{
                            field: "Applied",
                            aggregate: "sum"
                            },
                        {
                            field: "Assigned",
                            aggregate: "sum"
                            }, {
                            field: "Balance",
                            aggregate: "count"
                            }]
                    }, {
                    field: "MonthName",
                    aggregates: [{
                            field: "Applied",
                            aggregate: "sum"
                            },
                        {
                            field: "Assigned",
                            aggregate: "sum"
                            }, {
                            field: "Balance",
                            aggregate: "count"
                            }]
                    }],
                aggregate: [{
                        field: "Applied",
                        aggregate: "sum"
                            },
                    {
                        field: "Assigned",
                        aggregate: "sum"
                            },
                    {
                        field: "Balance",
                        aggregate: "count"
                            }],

            });

            $scope.KendoGridOptions = {


                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [

                    {
                        field: "MonthName",
                        title: "Month",
                        hidden: true,
                        },
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        hidden: true,
                        headerTemplate: "{{LanguageData.Employee}}",
                        },
                    {
                        field: "PayrollComponent.Name",
                        title: "Leave Type",
                        headerTemplate: "{{LanguageData.LeaveType}}",

                        },
                    {
                        field: "DateString",
                        title: "DateString",
                        headerTemplate: "{{LanguageData.Date}}",

                        },
                    {
                        field: "Assigned",
                        title: "Assigned",
                        template: "<div  style='text-align: right'>#=kendo.toString(Assigned, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: "{{LanguageData.Assigned}}",

                        },
                    {
                        field: "Applied",
                        title: "Applied",
                        template: "<div  style='text-align: right'>#=kendo.toString(Applied, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: "{{LanguageData.Applied}}",

                        },
                    {
                        field: "Balance",
                        title: "Balance",
                        template: "<div  style='text-align: right'>#=kendo.toString(Balance, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(count, 'n')#",
                        footerTemplate: "#=kendo.toString(count, 'n')#",
                        },

                    ],
            };



            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.print = function () {

                $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                $scope.filter.FromDay = $scope.filter.FromDate.getDate();
                $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

                $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                $scope.filter.ToDay = $scope.filter.ToDate.getDate();
                $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();



                MainService.PrintCPVMasterReport($scope.filter).then(function (response) {
                    if (response.data != null) {
                        $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }


        }])
